export class GetDocReviewTaskErrorEvent {
  constructor(
    public error: string
  ) {
  }
}
